import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { authInterceptor } from './shared/services/auth-interceptor.service';
import { csrfInterceptor } from './shared/services/auth-csrf-interceptor.service';
import { sharedConfig } from './shared/shared.config';
import { routes } from './app.routes';
import { authenticationConfig } from './views/authentication/authentication.config';
import { userManagmentConfig } from './views/user-management/user-mgmt.config';
import { labsConfig } from './views/labs/lab.config';
import { notificationsConfig } from './views/notifications/notifications.config';
import { projectsConfig } from './views/projects/project.config';
import { datasetsConfig } from './views/datasets/datasets.config';
import { metadataTagsConfig } from './views/metadata-tags/metadata-tags.config';
import { dashboardConfig } from './views/dashboard/dashboard.config';
import { domainAllowlistConfig } from './views/domain-allowlist/domain-allowlist.config';
import { metadataMgmtConfig } from './views/metadata-mgmt/metadata-mgmt.config';
import { organizationManagementConfig } from './views/organization-management/organization-management.config';
import { validationRulesConfig } from './views/validation-rules/validation-rules.config';
import { loaderInterceptor } from './shared/interceptors/loader.interceptor';
import { ThemeService } from './shared/services/theme.service';
import { resetStateOnSessionChange } from './shared/state/meta-reducers/reset-state.meta-reducer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideStore({}, { metaReducers: [resetStateOnSessionChange] }),
    provideEffects([]),
    provideStoreDevtools({ maxAge: 25 }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(() => inject(ThemeService).init()),
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),

    ...sharedConfig,
    ...authenticationConfig,
    ...userManagmentConfig,
    ...labsConfig,
    ...notificationsConfig,
    ...projectsConfig,
    ...datasetsConfig,
    ...metadataTagsConfig,
    ...dashboardConfig,
    ...domainAllowlistConfig,
    ...metadataMgmtConfig,
    ...organizationManagementConfig,
    ...validationRulesConfig,
    provideHttpClient(withInterceptors([authInterceptor, csrfInterceptor, loaderInterceptor])),
  ],
};
